<template>
  <v-card
    elevation="1"
    class="rounded-lg d-flex align-center pgm-dashboard-container billboard-container"
    :class="backgroundClass"
    :style="backgroundStyle"
  >
    <!-- <img
      v-if="config?.image?.url"
      class="rounded dashboard-image"
      :src="config.image?.url"
    /> -->
    <div
      v-if="activeTextConfig && activeTextConfig.text"
      class="overlay-text"
      :style="overlayTextStyle"
      :class="overlayTextClass"
    >
      <span>
        {{ activeTextConfig.text }}
      </span>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "Billboard",
  props: {
    config: {
      type: Object,
      required: true,

      // Developer note:
      // This schema is for readability - it doesn't actually restrict anything on the Vue side
      image: {
        type: Object,
        required: false,
        url: {
          type: String,
          required: true,
        },
      },
      background: {
        type: Object,
        required: false,
        color: {
          type: String,
          required: false,
        },
        gradient: {
          type: String,
          required: false,
        },
      },
      overlay: {
        type: Object,
        required: false,
        text: {
          type: String,
          required: true,
        },
        color: {
          type: String,
          required: false,
          default: "black",
        },
        bold: {
          type: Boolean,
          required: false,
          default: false,
        },
        italic: {
          type: Boolean,
          required: false,
          default: false,
        },
        underline: {
          type: Boolean,
          required: false,
          default: false,
        },
        horizontalAlignment: {
          type: String,
          required: false,
          default: "left",
          //   start, center, end
        },
        verticalAlignment: {
          type: String,
          required: false,
          default: "top",
          //   start, center, end
        },
      },
    },
    data: {
      type: Object,
      required: false,
      default: null,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activeTextConfig() {
      const overlay = this.config && this.config.overlay;
      const title = this.config && this.config.title;
      return overlay != null ? overlay : title != null ? title : null;
    },
    backgroundStyle() {
      let style = {};

      if (this.config?.aspectRatio) {
        const parts = this.config.aspectRatio.split(":");
        if (parts.length === 2) {
          style["aspect-ratio"] = `${parts[0]} / ${parts[1]}`;
        }
      }

      if (this.config?.background?.gradient) {
        style["background"] = this.config?.background?.gradient;
      } else if (this.config?.background?.color) {
        style["background-color"] = this.config?.background?.color;
      } else if (this.config?.image?.url) {
        style["background-image"] = `url(${this.config?.image?.url})`;
        style["background-size"] = "cover";
        style["background-position"] = "center";
        style["background-repeat"] = "no-repeat";
      }

      return style;
    },
    backgroundClass() {
      let classList = ``;
      // classList += ` dashboard-image-${this.config?.image?.url ? "true" : "false"}`;
      return classList;
    },
    overlayTextStyle() {
      let style = {
        color: "black",
        // height: "auto"
      };

      style.color = (this.activeTextConfig && this.activeTextConfig.color) || "brandCyan";

      return style;
    },
    overlayTextClass() {
      let classList = "d-flex full-width full-height pa-5";
      //   classList += ` pgm-dashboard-text-${this.config.overlay.size || "md"}`;
      const hAlignMap = { left: "start", center: "center", right: "end" };
      const hAlign =
        hAlignMap[this.activeTextConfig && this.activeTextConfig.horizontalAlignment] ||
        (this.activeTextConfig && this.activeTextConfig.horizontalAlignment) ||
        "start";
      classList += ` pgm-dashboard-text-${
        (this.activeTextConfig && this.activeTextConfig.size) || "md"
      } align-${
        (this.activeTextConfig && this.activeTextConfig.verticalAlignment) || "start"
      } justify-${hAlign}`;

      if (this.activeTextConfig && this.activeTextConfig.bold) {
        classList += " font-weight-bold";
      }
      if (this.activeTextConfig && this.activeTextConfig.italic) {
        classList += " font-italic";
      }
      if (this.activeTextConfig && this.activeTextConfig.underline) {
        classList += " text-decoration-underline";
      }

      return classList;
    },
  },
};
</script>
<style scoped>
.billboard-container {
  aspect-ratio: 4 / 1;
  width: 100%;
  height: auto;
}

.dashboard-image {
  object-fit: fill;
  width: 100%;
  height: auto;
}

.overlay-text {
  position: absolute;
}
</style>
